<template>
	<div :style="{width:w,height:h}">
		<canvas :id="uid" class="canvas" :data-uid="uid"></canvas>
	</div>
	
</template>

<script>
  import SignaturePad from 'signature_pad'
  export default {
    name: 'SignaturePad',
    props: {
      sigOption: {
        type: Object,
        default: () => ({ penColor: 'rgb(0, 0, 0)' })
      },
      w: {
        type: String,
        default: '100%'
      },
      h: {
        type: String,
        default: '100%'
      }
    },
    data () {
      return {
        sig: () => {},
        uid: ''
      }
    },
    created () {
      this.uid = 'canvas' + this._uid
    },
    methods: {
      draw () {
        var canvas = document.getElementById(this.uid)
        this.sig = new SignaturePad(canvas, this.sigOption)

        function resizeCanvas () {
          var data = canvas.toDataURL()

          var context = canvas.getContext('2d')
          var ratio = Math.max(window.devicePixelRatio || 1, 1)
          canvas.width = canvas.offsetWidth * ratio
          canvas.height = canvas.offsetHeight * ratio
          canvas.getContext('2d').scale(ratio, ratio)

          var img = new Image()
          img.onload = function () {
            context.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height)
          }
          img.src = data
        }
        window.addEventListener('resize', resizeCanvas)
        resizeCanvas()
      },
      clear () {
        this.sig.clear()
      },
      save (format) {
        return format ? this.sig.toDataURL(format) : this.sig.toDataURL()
        // signaturePad.toDataURL(); // save image as PNG
        // signaturePad.toDataURL("image/jpeg"); // save image as JPEG
        // signaturePad.toDataURL("image/svg+xml"); // save image as SVG
      }
    },
    mounted () {
      this.draw()
    }
  }
</script>

<style>
  canvas {
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Tools/SignaturePad.vue